import * as Yup from "yup";

const DocumentUploadValidationSchema = Yup.object().shape({
  documentname: Yup.string()
    .required("Please enter document name")
    .max(50, "Document name cannot be longer than 40 characters.")
    .matches(/^[A-Za-z0-9\s()-.]+$/, 'Please enter an document name using letters and digits only.'),
    documentUpload: Yup.string()
    .required("Please select a PDF document."),
});

export default DocumentUploadValidationSchema;
